import * as yup from 'yup'

import { SsoFields } from './sso.types'

export const ssoSchema = yup.object().shape({
    [SsoFields.email]: yup.string().email('AUTH.EMAIL_NOT_VALID').required('AUTH.REQUIRED_FIELD'),
})
